import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'
import { faCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules'
import { faPlane } from '@fortawesome/pro-regular-svg-icons/faPlane'
import { hengenixPatientPhoto } from '@modules/images/pages/trials'

export const HardcodedHengenixPaidContent = ({ nctId }: { nctId: string }) => {
  if (!['NCT05353257', 'NCT05468489'].includes(nctId)) {
    return null
  }
  return (
    <div className='rounded-lg bg-neutral100'>
      <div className='flex flex-col-reverse gap-8 md:flex-row'>
        <div className='flex w-full flex-col gap-2 px-4 pb-4 md:w-2/3 md:py-8 md:pl-8'>
          <Text
            styleName='h3'
            value='100% of travel, accommodation, and treatment cost is covered.'
          />
          <Text
            styleName='p-small'
            value='The company running this study will pay for:'
          />
          <div>
            <div className='flex gap-2 align-middle'>
              <Icon className='pt-2 text-blue500' icon={faCapsules} />
              <Text
                styleName='p-small'
                value='Chemotherapy medication & the investigational drug or Atezolizumab (standard of care) depending on which group a patient is assigned to.'
              />
            </div>
            <div className='flex gap-2 align-middle'>
              <Icon className='pt-2 text-blue500' icon={faPlane} />
              <Text
                styleName='p-small'
                value='Travel, accommodation, and meals required to support your participation in the trial.'
              />
            </div>
          </div>
        </div>
        <CloudflareImage
          alt='Patient Care'
          className='w-full rounded-t-lg md:w-1/3 md:rounded-r-lg'
          height={350}
          imageId={hengenixPatientPhoto}
          width={541}
        />
      </div>
    </div>
  )
}
